<style lang="less" scoped>
@import url('../../../style/common/variable.less');
@media screen and (min-width: @max-screen)
{
  .country{width: 1200px;margin: auto;}
  .navigation{display: block; text-align: left; margin:auto;margin-top: 20px;margin-bottom: 20px;}
  .left{width: 775px;margin-top: 30px;float: left;}
}
@media screen and (max-width: @max-screen)
{
  .country{width: 100%;margin: auto;}
  .left{width: 96%;margin: auto;}
}
.sjgx{width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;}

// .navigation{display: block; text-align: left; margin:auto;margin-top: 20px;margin-bottom: 20px;}
// .navigation span{font-size: 18px;font-weight: bold;}
// .left{width: 775px;margin-top: 30px;float: left;}
.time{margin-right: 30px;}
.copyfrom{margin-right: 30px;}
.font{font-weight: bold;}
.content{overflow: hidden;}
.right{width: 370px;height:293px;border: 1px solid #f7f3f3;margin-left: 810px;top: 130px;box-shadow:2px 2px 2px 3px rgb(238, 235, 235);}
.touxiang{margin-top: 45px;}
.touxiang img{width: 97px;height: 97px;}
.zzname{margin-top: 15px;font-weight: bold;font-size: 18px;}
.button{width: 100px; font-size: 16px;margin-top: 20px;box-shadow:1px 1px 1px 1px rgb(238, 235, 235);}
.rights{width: 370px;margin-left: 810px;top: 470px;cursor: pointer;}
i{font-size: 19px;color: #289FDE;vertical-align: middle;margin-right: 5px;}
h3{line-height: 50px;text-align: left;margin:0;font-size: 18px;}
.box1{display:inline-flex;width: 370px;border-bottom: 1px solid #f3ecec;}
.imgs{margin-top: 5px;}
.imgs img{width: 100px;height: 70px;}
.titles{width: 200px;height: 70px;margin-top: 15px;margin-left: 15px;}
.spans{display: block;text-align: left;line-height: 27px; white-space: nowrap;text-overflow:ellipsis;overflow:hidden;}
.span1{display: block;text-align: left;line-height: 27px;}
</style>

<!--李旭 2021.7.7 专家智库详情页-->
<template>
  <div class="sjgx">
    <div class="main">
      <div class="country"><National></National></div>
      <div class="navigation">
        <!-- <span>专家智库  </span> -->
      </div>
      <div>
        <div class="left">
          <div class="first">
            <h2 class="title">{{ curArticle[0].title }}</h2>
            <div class="subbox">
              <span class="font">发布时间：</span><span class="time">{{ curArticle[0].time * 1000 | formatDate() }} </span>
              <span class="font">信息来源：</span><span class="copyfrom">{{ curArticle[0].copyfrom }}</span>
              <span class="font">浏览数：</span><span class="hits">{{ curArticle[0].hits }}</span>
            </div>
            <div class="content" v-html="curArticleContent" :style="{height: this.heightCSH + 'px'}"></div>
          </div>
          <el-button round @click="getOthers" style="width: 240px;font-size: 16px;margin: 40px 0px">加载更多</el-button>
        </div>
        <div v-if="ifShowFlag">
          <div class="right">
            <div class="touxiang">
              <img src="static/images/zlkindex/touxiang.webp" alt="">
            </div>
            <div class="zzname">
              <span>{{ namelist.length > 0 ? namelist[0].truename : '暂无' }}</span>
            </div>
            <div>
              <el-button class="button" @click="zjDetail(namelist.length > 0 ? namelist[0].id : '')" >他的专栏</el-button>
              <el-button class="button" @click="zxDetail()">最新文章</el-button>
            </div>
          </div>
          <div class="rights">
            <h3><i class="iconfont icon-rementuijian"></i>猜你喜欢 / Guess you like</h3>
            <div class="box1" v-for="(item,index) in items" :key=index @click="getzkDetail(item)">
              <div class="imgs">
                <img :src='item.thumb' alt="">
              </div>
              <div class="titles">
                <span class="spans">{{item.title}}</span>
                <span class="span1">{{item.addtime * 1000 | formatDate()}}</span>
              </div>
            </div>
            <el-button round @click="getOther" style="width: 240px;font-size: 16px;margin: 40px 0px;">加载更多</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import National from '../assembly/National'
import Details from '../assembly/Details'
import {mapState} from 'vuex'
import filters from '../method/filter.js'
export default {
  components: {
    National,
    Details
  },
  name: '',
  mixins: [filters],
  data()
  {
    return {
      namelist: [],
      curArticle: {}, // 当前展示文章的相关信息
      curArticleContent: {},
      heightCSH: 900,
      ZjList: [],
      items: [],
      ifShowFlag: true
    }
  },
  computed: {
    ...mapState({
      ZjzkID: state => state.ZjzkID.id  //获取当前点击的产品id
    })
  },
  created()
  {
    this.getZjList()
  },

  mounted()
  {
    if (window.innerWidth > 912)
      this.ifShowFlag = true
    else
      this.ifShowFlag = false
  },


  watch:
  {
    $route:
    {
      handler(nval, oval)
      {
        this.getCurArticle(+nval.query.id)
        this.getCurArticleContent(+nval.query.id)
      },
      // deep: true,
      immediate: true
    }
  },
  methods: {
    getCurArticle(itemid)
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 45, _exp: 'id=? and examine = 0', types: 'i', vals: itemid}
      window.post.getPost(paras1).then((ret) =>
      {
        let arr = []
        ret.forEach(item =>
        {
          arr.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, username: item.username})
          //获取作者名字
          let paras2 = {cmd: 'query', _major: 11, _minor: 28, _exp: `username='${item.username}'`}
          window.post.getPost(paras2).then(data =>
          {
            if (data.length > 0)
            
              this.namelist.push({id: data[0].id, truename: data[0].truename})
          })
        })
        this.curArticle = arr
      })
    },
    getCurArticleContent(itemid)
    {
      let paras1 = {cmd: 'query', _major: 11, _minor: 46, _exp: 'id=?', types: 'i', vals: itemid}
      window.post.getPost(paras1).then((ret) =>
      {
        this.curArticleContent = window.public.decodeContent(ret[0].content)
      })
    },
    getZjList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 45, _exp: 'id>0 and examine = 0', orderby: 'addtime DESC'}
      window.post.getPost(paras).then((ret) =>
      {
        this.categorydata = []
        ret.forEach(item =>
        {
          this.categorydata.push({id: item.id, title: item.title, addtime: item.addtime, thumb: item.thumb ? item.thumb : 'static/images/moren.jpg'})
        })
        this.ZjList = this.categorydata
        // 初始化页面数据
        this.items = []
        if (this.ZjList.length >= 5)
        {
          for (let i = 0; i < 5; i++)
            this.items.push(this.ZjList[i])
        }
        else
        {
          for (let i = 0; i < this.ZjList.length; i++)
            this.items.push(this.ZjList[i])
        }
        this.num = 0
      })
    },
    // 点击加载更多
    getOthers()
    {
      this.heightCSH += 1600
    },
    getOther()
    {
      this.num += 1
      for (let i = 0; i < 5; i++)
        this.items.push(this.ZjList[i + this.num * 5])
    },
    zjDetail(val)
    {
      if (val)
      {
        let url = this.$router.resolve({path: '/ZjDetails', query: {id: val}})
        window.open(url.href, '_blank')
      }
      else
        this.$message({message: '暂无', type: 'error'})
    },
    zxDetail()
    {
      this.$message({message: '暂无', type: 'error'})
    },
    getzkDetail(item)
    {
      let url = this.$router.resolve({path: '/ZhikuDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZhikuDetails.vue